import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input"]
    static values = {
        maxSize: Number
    }

    connect() {
        this.validateFileSize = this.validateFileSize.bind(this)
        this.inputTarget.addEventListener('change', this.validateFileSize)
    }

    disconnect() {
        this.inputTarget.removeEventListener('change', this.validateFileSize)
    }

    validateFileSize(event) {
        const files = event.target.files
        if (files.length > 0 && this.hasMaxSizeValue) {
            const file = files[0]
            if (file.size > this.maxSizeValue) {
                event.target.value = ''
                alert(`File size must be less than ${this.formatBytes(this.maxSizeValue)}`)
            }
        }
    }

    removeFile(event) {
        event.preventDefault()
        this.inputTarget.value = ''
        event.target.closest('.current-file').remove()
    }

    formatBytes(bytes) {
        const units = ['B', 'KB', 'MB', 'GB']
        let size = bytes
        let unit = 0

        while (size >= 1024 && unit < units.length - 1) {
            size /= 1024
            unit++
        }

        return `${size.toFixed(2)} ${units[unit]}`
    }
}